import { render } from "./ColorPickerSlider.vue?vue&type=template&id=68d60117&scoped=true&ts=true&lang=html"
import script from "./ColorPickerSlider.vue?vue&type=script&lang=ts"
export * from "./ColorPickerSlider.vue?vue&type=script&lang=ts"

import "./ColorPickerSlider.vue?vue&type=style&index=0&id=68d60117&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d60117"]])

export default __exports__